import { bundleCustomisationProps } from 'src/components/BundleProduct/utils/formToCustomisation';

export const validateArtwork = (artworkData: bundleCustomisationProps) => {
    let logoError = false;
    let textError = false;
    let emptyCustomisation = false;

    Object.values(artworkData).map((artwork) => {
        const type = artwork && artwork['bundle-customisation'] && artwork['bundle-customisation'].applicationType;
        const logo = artwork && artwork['bundle-customisation'] && artwork['bundle-customisation'].image;
        const text = artwork && artwork['bundle-customisation'] && artwork['bundle-customisation'].textLineOne;
        const contactRequested =
            artwork && artwork['bundle-customisation'] && artwork['bundle-customisation'].isContactRequested;
        const artworkId = artwork && artwork['artwork'];

        if (type === 'logo' && !logo && contactRequested === 'upload') {
            logoError = true;
        }
        if (type === 'text' && !text) {
            textError = true;
        }
        if (!artworkId) {
            emptyCustomisation = true;
        }
    });

    const usedPositions: string[] = Object.values(artworkData).map(
        (artwork) => artwork && artwork['bundle-customisation-location'],
    );

    const positionError = usedPositions && usedPositions[0] === usedPositions[1];
    const isValid = !logoError && !textError && !emptyCustomisation && !positionError;
    const errors = { logoError, textError, positionError, emptyCustomisation };

    return {
        isValid,
        errors,
    };
};
